/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 467);
/******/ })
/************************************************************************/
/******/ ({

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(468);


/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(469);

__webpack_require__(470);

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(false) {
      // 1749448645969
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * HR Microsite - Light Side
 */
(function ($) {

	$('#scroll-bottom').on('click', function (e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop: $("#bottom").offset().top
		}, 1000, 'linear');
	});

	$('.btn-long-top').on('click', function (e) {
		dataLayer.push({
			'event': 'fgWebAnalytics',
			'fgVarCat': 'Microsite svetla strana sily',
			'fgVarAct': 'Proklik tlacitka pridej se',
			'fgVarLbl': 'Dlouha - prvni sekce'
		});
	});

	$('.btn-long-bottom').on('click', function (e) {
		dataLayer.push({
			'event': 'fgWebAnalytics',
			'fgVarCat': 'Microsite svetla strana sily',
			'fgVarAct': 'Proklik tlacitka pridej se',
			'fgVarLbl': 'Dlouha - druha sekce'
		});
	});

	$('.btn-short-top').on('click', function (e) {
		dataLayer.push({
			'event': 'fgWebAnalytics',
			'fgVarCat': 'Microsite svetla strana sily',
			'fgVarAct': 'Proklik tlacitka pridej se',
			'fgVarLbl': 'Kratka - prvni sekce'
		});
	});

	$('.btn-short-middle').on('click', function (e) {
		dataLayer.push({
			'event': 'fgWebAnalytics',
			'fgVarCat': 'Microsite svetla strana sily',
			'fgVarAct': 'Proklik tlacitka pridej se',
			'fgVarLbl': 'Kratka - druha sekce'
		});
	});

	$('.btn-short-bottom').on('click', function (e) {
		dataLayer.push({
			'event': 'fgWebAnalytics',
			'fgVarCat': 'Microsite svetla strana sily',
			'fgVarAct': 'Proklik tlacitka pridej se',
			'fgVarLbl': 'Kratka - treti sekce'
		});
	});

	$('.btn-ana-top').on('click', function (e) {
		dataLayer.push({
			'event': 'fgWebAnalytics',
			'fgVarCat': 'Microsite svetla strana sily',
			'fgVarAct': 'Proklik tlacitka pridej se',
			'fgVarLbl': 'Analytik - prvni sekce'
		});
	});

	$('.btn-ana-middle').on('click', function (e) {
		dataLayer.push({
			'event': 'fgWebAnalytics',
			'fgVarCat': 'Microsite svetla strana sily',
			'fgVarAct': 'Proklik tlacitka pridej se',
			'fgVarLbl': 'Analytik - druha sekce'
		});
	});

	$('.btn-ana-bottom').on('click', function (e) {
		dataLayer.push({
			'event': 'fgWebAnalytics',
			'fgVarCat': 'Microsite svetla strana sily',
			'fgVarAct': 'Proklik tlacitka pridej se',
			'fgVarLbl': 'Analytik - treti sekce'
		});
	});
})(jQuery);

/***/ })

/******/ });


// WEBPACK FOOTER //
// web-lightSide.js